export default __webpack_public_path__ + "static/media/Filter.8078e94e.svg";